import { memo, useState } from "react";
import Demo from "./Demo/Demo";
import Name from "./Name/Name";
import Highlight from "./Highlight/Highlight";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import MultipleArticlesTop from "@coworker/apprestructured/src/task-management/components/MultipleArticlesTop/MultipleArticlesTop";
import { ItemWithQuantity } from "@coworker/apprestructured/src/task-management/components/AttachArticles/AttachArticles";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";

function MultipleArticlesTopDemo() {
  const [loading, setLoading] = useState(false);

  const articles: ItemWithQuantity[] = [
    {
      no: "30373588",
      type: "ART",
      name: "Article 1",
      noFormatted: "303.735.88",
      description: "Description for Article 1",
      productTypeName: "mockProductType",
      paNo: "123",
      hfbNo: "123",
      source: "source",
      imageUrl:
        "https://www.ikea.com/se/en/images/products/blahaj-soft-toy-shark__0710175_pe727378_s5.jpg",
      smallImageUrl:
        "https://www.ikea.com/se/en/images/products/blahaj-soft-toy-shark__0710175_pe727378_s5.jpg",
      quantity: 1,
    },
    {
      no: "123456123",
      type: "ART",
      name: "Article 2",
      noFormatted: "123.456.123",
      description: "Description for Article 2",
      productTypeName: "mockProductType",
      paNo: "123",
      hfbNo: "123",
      source: "source",
      imageUrl:
        "https://www.ikea.com/se/en/images/products/eket-cabinet-brown-walnut-effect__1132779_pe878298_s5.jpg",
      smallImageUrl:
        "https://www.ikea.com/se/en/images/products/eket-cabinet-brown-walnut-effect__1132779_pe878298_s5.jpg",
      quantity: 1,
    },
    {
      no: "40586508",
      type: "ART",
      name: "Article 3",
      noFormatted: "405.865.08",
      description: "Description for Article 3",
      productTypeName: "mockProductType",
      paNo: "123",
      hfbNo: "123",
      source: "source",
      imageUrl:
        "https://www.ikea.com/se/en/images/products/stockholm-2025-tv-bench-with-sliding-doors-oak-veneer__1397700_pe967721_s5.jpg",
      smallImageUrl:
        "https://www.ikea.com/se/en/images/products/stockholm-2025-tv-bench-with-sliding-doors-oak-veneer__1397700_pe967721_s5.jpg",
      quantity: 1,
    },
    {
      no: "1234616628",
      type: "ART",
      name: "Article 4",
      noFormatted: "123.412.74",
      description: "Description for Article 4",
      productTypeName: "mockProductType",
      paNo: "123",
      hfbNo: "123",
      source: "source",
      imageUrl:
        "https://www.ikea.com/se/en/images/products/soederhamn-cover-for-1-seat-section-kelinge-grey-turquoise__1241938_pe919982_s5.jpg",
      smallImageUrl:
        "https://www.ikea.com/se/en/images/products/soederhamn-cover-for-1-seat-section-kelinge-grey-turquoise__1241938_pe919982_s5.jpg",
      quantity: 1,
    },
    {
      no: "1234162812398",
      type: "ART",
      name: "Article 5",
      noFormatted: "123.771.92",
      description: "Description for Article 5",
      productTypeName: "mockProductType",
      paNo: "123",
      hfbNo: "123",
      source: "source",
      imageUrl:
        "https://www.ikea.com/se/en/images/products/baestis-lint-roller-grey__0654805_pe708843_s5.jpg",
      smallImageUrl:
        "https://www.ikea.com/se/en/images/products/baestis-lint-roller-grey__0654805_pe708843_s5.jpg",
      quantity: 1,
    },
  ];

  return (
    <Demo>
      <Name>MultipleArticles Top</Name>
      <Highlight>
        <MultipleArticlesTop
          articles={loading ? LOADING : articles}
          state={LOADING}
        />
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="loading"
          value="MultipleArticles-loading"
          id="MultipleArticles-loading"
          checked={loading}
          onChange={() => setLoading((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(MultipleArticlesTopDemo);
